import React from "react";
import { useTranslation } from "react-i18next";

const DEFAULT_LANGS = [
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" },
];

// v414.87 — `langs` lets surfaces pick their own set (storefront: EN/ES).
// A click marks the choice as EXPLICIT so store auto-defaults never override it.
export default function LanguageToggle({ className = "", langs = null }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  const LANGS = langs
    ? langs.map((c) => ({ code: c, label: c.toUpperCase() }))
    : DEFAULT_LANGS;

  return (
    <div
      data-testid="language-toggle"
      className={`inline-flex items-center rounded-md border border-zinc-200 bg-white p-0.5 ${className}`}
      role="group"
      aria-label="Language"
    >
      {LANGS.map((l) => {
        const active = current === l.code;
        return (
          <button
            key={l.code}
            type="button"
            data-testid={`lang-${l.code}`}
            onClick={() => {
              try { localStorage.setItem("reup-lang-user", "1"); } catch { /* private mode */ }
              i18n.changeLanguage(l.code);
            }}
            className={`h-7 px-2.5 text-[11px] font-semibold rounded transition-colors ${
              active ? "bg-zinc-900 text-white" : "text-zinc-600 hover:text-zinc-900"
            }`}
            aria-pressed={active}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
